export enum FileContentTypeEnum {
    EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    CSV = 'text/csv'
}
